/**
 * @desc 批量更新打印状态
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<number>, options?: any) {
  return updateResponse(
    http(URL + `/financeVoucherReport/updatePrint`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
